// Reusable header styles for the Pre-built library. Each = a small block group
// inserted at the TOP of the email. Users replace the placeholder logo with theirs.
import { headerBar, heading, text, spacer } from './builders'

const HEADERS = [
  {
    id: 'hdr-logo-centered',
    name: 'Logo — Centered',
    blocks: [
      headerBar({ desktopLayout: 'logo_centered', links: [], logoAlt: 'Your Logo', backgroundColor: '#ffffff', paddingTop: 20, paddingBottom: 20 }),
    ],
  },
  {
    id: 'hdr-logo-left-nav',
    name: 'Logo Left + Nav Links',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline', logoAlignment: 'left', backgroundColor: '#ffffff',
        links: [
          { id: 'h1', kind: 'link', label: 'Shop', url: '#' },
          { id: 'h2', kind: 'link', label: 'About', url: '#' },
          { id: 'h3', kind: 'link', label: 'Contact', url: '#' },
        ],
        linkColor: '#1A1A1A', linkFontSize: 15, paddingTop: 14, paddingBottom: 14,
      }),
    ],
  },
  {
    id: 'hdr-logo-tagline',
    name: 'Logo + Tagline Banner',
    blocks: [
      headerBar({ desktopLayout: 'logo_centered', links: [], backgroundColor: '#ffffff', paddingTop: 22, paddingBottom: 6 }),
      text('<p style="text-align:center">Your one-line brand promise goes here</p>', { alignment: 'center', color: '#6B7280', fontSize: '13', paddingTop: 0, paddingBottom: 18 }),
    ],
  },
  {
    id: 'hdr-color-bar',
    name: 'Bold Color Bar',
    blocks: [
      headerBar({
        desktopLayout: 'logo_inline', logoAlignment: 'left', backgroundColor: '#111827',
        links: [
          { id: 'c1', kind: 'link', label: 'Shop', url: '#' },
          { id: 'c2', kind: 'link', label: 'Deals', url: '#' },
        ],
        linkColor: '#ffffff', linkBold: true, linkFontSize: 15, paddingTop: 16, paddingBottom: 16,
      }),
    ],
  },
  {
    id: 'hdr-wordmark',
    name: 'Minimal Wordmark',
    blocks: [
      spacer(16),
      heading('YOUR BRAND', { alignment: 'center', fontSize: '26', fontWeight: '800', color: '#111827', paddingTop: 6, paddingBottom: 6 }),
    ],
  },
]

export default HEADERS
